import React from "react";

const DefaultCase = () => {
  return <div>Form Failed to Submit</div>;
};

export default DefaultCase;
